<template>
	<section class="external-container query-wrap pc-wrap">
		<div>
			<div class="query-title">外部用工管理</div>
			<div class="check-form">
				<el-form>
					<el-form-item >
						<el-input v-model="searchForm.name"  placeholder="请输入姓名"></el-input>
					</el-form-item>
					<el-form-item>
						<el-input v-model="searchForm.phone"  placeholder="请输入手机号码"></el-input>
					</el-form-item>
					<el-form-item>
						<el-input v-model="searchForm.email"  placeholder="请输入个人邮箱"></el-input>
					</el-form-item>
					<el-form-item>
						<el-input v-model="searchForm.bizId"  placeholder="请输入流程ID"></el-input>
					</el-form-item>
					<el-form-item>
						<el-select v-model="searchForm.status" clearable placeholder="请选择流程状态">
							<el-option
								v-for="item in statusList"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="width50">
						<el-select
							v-model="searchForm.deptFullId"
							:remote-method="getDeptInfo"
							filterable
							clearable
							remote
							placeholder="请输入部门名称关键词"
							@focus="deptinfoList=[]"
							@clear="deptinfoList=[]">
							<el-option
								v-for="item in deptinfoList"
								:key="item.deptFullId"
								:label="item.name"
								:value="item.deptFullId">
                				<span>{{item.id}}/{{ item.deptFullName }}</span>
							</el-option>
						</el-select>
						<el-checkbox v-model="includeSub">是否包含子部门</el-checkbox>
					</el-form-item>
					<el-form-item class="width50">
						<el-date-picker
							v-model="entryDate"
							type="daterange"
							value-format="yyyy-MM-dd"
							format="yyyy-MM-dd"
							:default-time="['00:00:00', '23:59:59']"
							range-separator="至"
							start-placeholder="入职开始日期"
							end-placeholder="入职结束日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item class="width50">
						<el-date-picker
							v-model="approveDate"
							type="daterange"
							value-format="yyyy-MM-dd"
							format="yyyy-MM-dd"
							:default-time="['00:00:00', '23:59:59']"
							range-separator="至"
							start-placeholder="审批完成日期起"
							end-placeholder="审批完成日期止">
						</el-date-picker>
					</el-form-item>
					<br/>
					<el-form-item>
						<el-select
							v-model="searchForm.company"
							@change="companyChange"
							clearable
							placeholder="请选择合同主体">
							<el-option
								v-for="item in companyTypeList"
								:key="item.companyCode"
								:label="item.companyName"
								:value="item.companyCode">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select
							v-model="searchForm.empType"
							clearable
							placeholder="请选择人员类别">
							<el-option
								v-for="item in emplTypeList"
								:key="item.emplTypeCode"
								:label="item.emplTypeName"
								:value="item.emplTypeCode">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item >
						<el-button type="primary" round size="small" @click="getList(1)" >查询</el-button>
						<el-button type="default" round size="small" @click="getDownFile">导出</el-button>
						<el-button type="primary" round size="small" @click="openExternalApply">offer录入</el-button>
					</el-form-item>
				</el-form>
				<!-- <div class="handle-btn">
					<el-button  type="primary" round size="small" @click="getList(1)" >查询</el-button>
					<el-button  type="default" round size="small" @click="getDownFile">导出</el-button>
				</div> -->
			</div>

			<div class="search-table">
				<el-table
					v-loading="loading"
					:data="labOurData"
					style="width: 100%">
					<el-table-column prop="bizId" label="流程ID" align="center" width="180"></el-table-column>
					<el-table-column prop="emplid" align="center" label="劳务工ID" width="100"></el-table-column>
					<el-table-column prop="name" align="center" label="劳务工姓名" width="100"></el-table-column>
					<el-table-column  align="center" label="性别">
						<template slot-scope="scope">
							<span v-if="scope.row.sex=== 'F'">女</span>
							<span v-if="scope.row.sex=== 'M'">男</span>
						</template>
					</el-table-column>
					<el-table-column prop="companyName" width="180" align="center" label="主体"></el-table-column>
					<el-table-column prop="deptDescr" label="部门" align="center" width="150"></el-table-column>
					<el-table-column prop="jobDescr" align="center" label="职务" width="180"></el-table-column>
					<el-table-column prop="expEntryDt" label="预计入职日期" align="center" width="120"></el-table-column>
					<el-table-column prop="entryDt" align="center" label="确认入职日期" width="120"></el-table-column>
					<el-table-column prop="entryPhone" label="手机" align="center" width="130">
						<template slot-scope="scope">
							<div class="entryPhone">
								<p>{{ scope.row.isWholePhoneFlag ? scope.row.wholePhone : scope.row.entryPhone }}</p>
								<!-- <span
									v-if="scope.row.wholePhone || scope.row.entryPhone"
									class="phone"
									:class="scope.row.isWholePhoneFlag ? 'showPhone' : ''"
									@click="getLabourPhone(scope.row, scope.$index)"></span> -->
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="entryEmail" label="邮箱" align="center" width="170"></el-table-column>
					<el-table-column
						align="center"
						width="100"
						label="状态">
						<template slot-scope="scope">
							<span v-if="scope.row.status=== '0'">创建中</span>
							<span v-if="scope.row.status=== '1'">审批中</span>
							<span v-if="scope.row.status=== '2'">审批未通过</span>
							<span v-if="scope.row.status=== '3'">审批通过</span>
							<span v-if="scope.row.status=== '4'">待入职</span>
							<span v-if="scope.row.status=== '5'">已入职</span>
							<span v-if="scope.row.status=== '6'">已取消</span>
							<span v-if="scope.row.status=== '7'">数据落地中</span>
							<span v-if="scope.row.status=== '8'">数据落地失败</span>
							<span v-if="scope.row.status=== '9'">待接收offer</span>
							<span v-if="scope.row.status=== '10'">已拒绝offer</span>
							<span v-if="scope.row.status=== '11'">待落地</span>
						</template>
					</el-table-column>
					<el-table-column width="100" align="center" prop="createUser" label="申请人ID"></el-table-column>
					<el-table-column prop="createUserName" label="申请人姓名" align="center" width="100"></el-table-column>
					<el-table-column fixed="right" label="操作" v-if="labOurData.length > 0" align="center" width="230">
						<template slot-scope="scope">
							<div class="handle">
								<a @click="goToDetail(scope.row)">查看详情</a>
								<a v-if="scope.row.cancelAuth === 'Y'" v-show="scope.row.status !== '1' && scope.row.status !== '5' && scope.row.status !== '6' && scope.row.status !== '7'" @click="cancel(scope.row, scope.$index)">取消</a> 
								<span v-if="scope.row.cancelAuth === 'Y' && scope.row.status === '6'">已取消</span>
								<a v-if="scope.row.confirmAuth === 'Y'" v-show="scope.row.status == '3' || scope.row.status == '8'" @click="confirmJoinStaff(scope.row, scope.$index)">确认入职</a> 
								<a
									v-if="scope.row.status === '1' || scope.row.status === '3'"
									@click="modifyInfo(scope.row, scope.$index)">修改信息</a>
								<a v-if="scope.row.status === '0'" @click="goToEdit(scope.row)">编辑</a>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-pagination
				background
				:hide-on-single-page="labOurData.length === 0"
				:page-size="pager.pageSize"
				layout="total, prev, pager, next"
				:total="pager.total"
				:current-page.sync="pager.current"
				@current-change="getList">
			</el-pagination>
		</div>
		<Modify
			:data='modifyData'
			:visible='dialogVisible'/>
	</section>
</template>

<script>

import {
	getDeptList, getListLabOur, getDownFile, cancalInfo, confirmInfo,
	getCompanyInfo, getEmpType, getLabourPhone,
} from '../../network'
import { staticList } from '../../network/staticList'
import Modify from '@/components/list/Modify'

export default {
	data() {
		return {
			loading:false,
			searchForm: {
				name: '',
				phone: '',
				email: '',
				deptFullId:'',
				status:'',
				bizId: '',
				includeSubDep: 'N',
			},
			entryDate:null,
			approveDate: null,
			deptinfoList: [],
			labOurData: [],
			companyTypeList: [],
			emplTypeList: [],
			statusList:[],
			pager:{
				current: 1,
				pageSize: 15,
				total:0,
			},
			includeSub: false,
			dialogVisible: false,
			modifyData: {},
		}
	},
	components: {
		Modify,
	},
	watch: {
		includeSub(val){
			if(val){
				this.searchForm.includeSubDep = 'Y'
			} else {
				this.searchForm.includeSubDep = 'N'
			}
		},
		entryDate(val) {
			if(val){
				this.searchForm.startEntryDt = val[0]
				this.searchForm.endEntryDt = val[1]
			} else {
				delete this.searchForm.startEntryDt
				delete this.searchForm.endEntryDt
			}
		},
		approveDate(val) {
			if(val){
				this.searchForm.startApproveDt = val[0]
				this.searchForm.endApproveDt = val[1]
			}else{
				delete this.searchForm.startApproveDt
				delete this.searchForm.endApproveDt
			}
		},
	},
	created() {
		document.title = '外部用工查询'
		//流程状态
		this.statusList = staticList.statusList;
		this.getList()
		// 获取公司主体
		this.getCompanyList()
		// 员工类别
		this.fetchEmpTypeList()
	},
	methods: {
		/* 搜部门 */
		getDeptInfo(query) {
			if (query !== '') {
				setTimeout(() => {
					this.deptinfoList = [];
					let params = {
						pageNum: 1,
						pageSize: 30,
						queryName: query,
					}
					return getDeptList(params).then((res)=>{
						let data =res.data
						if(data.code === 'S00000'){
							this.deptinfoList = data.data.list;
							this.deptinfoList.forEach((item)=>{
								if (this.$isQf) {
									if(item.deptFullName.match(/千峰合泰\/(\S*)/).length > 0){
										item.deptFullName = item.deptFullName.match(/千峰合泰\/(\S*)/)[1]
									}
								} else {
									if(item.deptFullName.match(/车好多集团\/(\S*)/).length > 0){
										item.deptFullName = item.deptFullName.match(/车好多集团\/(\S*)/)[1]
									}
								}
							})							
						} else {
							this.$message.error(data.message)
						}
					}).catch((error)=>{
						// this.$message.error(JSON.stringify(error))
					})
				}, 200);
			} else{
				this.deptinfoList = []	
			}
		},
		goToDetail(item){
			let routeData = this.$router.resolve({
				name: 'ApproveQuery',
				query: {
					bizId: item.bizId
				}
			})
			window.open(routeData.href, '_blank');
		},
		goToEdit(item){
			let routeData = this.$router.resolve({
				name: 'ExternalApply',
				query: {
					bizId: item.bizId,
					type: 'edit'
				}
			})
			window.open(routeData.href, '_blank');
		},
		cancel(item,index){
			// 二次确认
			this.$confirm('确定取消吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
				}).then(() => {
				return  cancalInfo({bizId: item.bizId}).then((res)=>{
					let data =res.data
					if(data.code === 'S00000'){
						this.$message.success('取消成功')
						// 更新状态
						this.$set(this.labOurData[index],'status','6')
					} else {
						this.$message.error(data.message)
					}
				}).catch((error)=>{
					// this.$message.error(JSON.stringify(error.response.data.message))
				})
			})
    	},
    	confirmJoinStaff(item,index){
			// 二次确认
			this.$confirm('确认入职吗?', '提示', {
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				type: 'warning'
				}).then(() => {
				return  confirmInfo({bizId: item.bizId}).then((res)=>{
					let data =res.data
					if(data.code === 'S00000'){
						this.$message.success('确认入职成功')
						// 更新状态
						this.$set(this.labOurData[index],'status','7')
					} else {
						this.$message.error(data.message)
					}
				}).catch((error)=>{
					// this.$message.error(JSON.stringify(error.response.data.message))
				})
			})
    	},
		// 导出批次数据
        getDownFile(){
            let params = {
				name: this.searchForm.name,
				phone: this.searchForm.phone,
				email: this.searchForm.email,
				deptFullId: this.searchForm.deptFullId,
				status: this.searchForm.status,
				bizId: this.searchForm.bizId,
				startEntryDt: this.searchForm.startEntryDt || '',
				endEntryDt: this.searchForm.endEntryDt || '',
				startApproveDt: this.searchForm.startApproveDt || '',
				endApproveDt: this.searchForm.endApproveDt || '',
				includeSubDep: this.searchForm.includeSubDep,
				company: this.searchForm.company,
				empType: this.searchForm.empType,
			}
			getDownFile(params).then((res)=>{
				let blob = new Blob([res.data])
				let elink = document.createElement('a');
				elink.download = '外部用工流程查询表.xlsx';
				elink.style.display = 'none';
				elink.href = URL.createObjectURL(blob);
				document.body.appendChild(elink);
				elink.click();
				URL.revokeObjectURL(elink.href); // 释放URL 对象
				document.body.removeChild(elink);
			})
        },
		// 查询
		getList(pageNum = this.pager.current){
			this.labOurData = []
			this.pager.total = 0
			this.loading = true
			let pages = {
				pageSize: this.pager.pageSize,
				pageNum: pageNum,
			}
			let params = Object.assign({},pages, this.searchForm)
			getListLabOur(params).then((res)=>{
				let data = res.data
				if(data.code === 'S00000'){
					this.labOurData = data.data.list || []
					this.pager.total = data.data.total || 0
					this.pager.current = params.pageNum
				} else {
					this.$message.error(data.message)
				}
				this.loading = false
			}).catch((error)=>{
				this.loading = false
				// this.$message.error(error.response.data.message)
			})
		},
		openExternalApply() {
			let routeData = this.$router.resolve({
				name: 'ExternalApply',
			})
			window.open(routeData.href, '_blank');
		},
		async getCompanyList() { // 获取公司主体下拉
			// NB 内部，WB 外部
			let res = await getCompanyInfo({ companyNature: 'WB' }).catch(() => {})
			if (!res) return
			this.companyTypeList = res.data.data || []
		},
		companyChange(company) {
			this.fetchEmpTypeList(company)
			this.$set(this.searchForm, 'empType', '')
		},
		// 员工类别
		fetchEmpTypeList(company = ''){
			(company ? getEmpType({ company }) : getEmpType()).then((res) => {
				let data = res.data
				if(data.code === 'S00000'){
					this.emplTypeList = data.data || [];
				} else {
					this.$message.error(data.message)
				}
			}).catch(() => {})
		},
		modifyInfo(data, index) {
			this.currentIndex = index
			this.dialogVisible = true
			this.modifyData = data
		},
		updateData(data) {
			let { entryDt, entryEmail, entryPhone } = data
			this.labOurData[this.currentIndex].entryDt = entryDt
			this.labOurData[this.currentIndex].entryEmail = entryEmail
			this.labOurData[this.currentIndex].entryPhone = entryPhone
		},
		// 查看完整手机号
		getLabourPhone(row, index) {
			if (row.wholePhone) {
				row.isWholePhoneFlag = !row.isWholePhoneFlag
				this.$set(this.labOurData, index, row)
				return
			}
			getLabourPhone({ bizId: row.bizId }).then((res) => {
				let { data: { data } } = res
				row.wholePhone = data
				row.isWholePhoneFlag = true
				this.$set(this.labOurData, index, row)
			})
		}
	},

};

</script>
<style>
*{
  margin:0;
  padding:0;
}
ul,li{
  list-style: none;
}
</style>
<style lang="scss">
	$--phone-hide: 'https://image1.guazistatic.com/qn2012101123278b3a6936f3e4681c0c98c403574492f3.png';
	$--phone-show: 'https://image1.guazistatic.com/qn2012101123381f9460239110a47e866036d4c20cd441.png';
	.el-notification{
		z-index: 11000!important;
	}
	.query-wrap{
		width: 1222px;
		box-sizing: border-box;
		margin: 70px auto 0;
		padding-bottom: 30px;
		.el-date-editor--daterange.el-input, 
		.el-date-editor--daterange.el-input__inner, 
		.el-date-editor--timerange.el-input, 
		.el-date-editor--timerange.el-input__inner{
			width: 288px;
		}
		.search-table{
			padding: 0 30px;
		}
		.el-table .cell{
			font-size: 13px;
		}
		.el-table th > .cell{
			font-size:14px;
		}
		.check-form{
			margin-bottom: 20px;
			padding-left:7px;
		}
		.el-table__fixed-right::before, 
		.el-table__fixed::before{
			background-color: transparent;
		}
		.el-form-item{
			display: inline-block;
			margin-left: 20px;
			margin-bottom: 10px;
			.el-date-editor--datetimerange.el-input,
			.el-date-editor--datetimerange.el-input__inner{
				width: 348px;
			}
		}
		.el-pagination{
			text-align:center;
			margin: 20px 0;
		}
		.handle-btn{
			text-align: right;
			margin-bottom: 30px;
		}
		.el-checkbox{
			color:#C0C4CC;
			margin-left: 10px;
		}
		.query-title{
			padding: 20px 0 15px 55px;
			color: #333333;
			font-size: 16px;
			position: relative;
			display: flex;
			align-items: flex-end;
			justify-content: center;
			border-bottom: 1px dashed #E5E5E5;
			margin-bottom: 30px;
			font-weight: bold;
			&::after{
				content:'';
				position: absolute;
				width:24px;
				height:15px;
				background:url('../../assets/icon-car.png') no-repeat;
				left: calc(50% - 50px);
				top: 24px;
				background-size:24px auto;
			}
		}
		.el-input{
			width: 172px;
		}
		.el-pagination.is-background .el-pager li:not(.disabled).active{
			background-color: #32B15F;
		}
		.el-date-editor .el-range-separator{
			color: #606266;
		}
		.handle{
			a{
				font-size: 12px;
				padding-right:10px;
				color: #32B15F;
				cursor: pointer;
			}
			span{
				padding-right:10px;
				font-size: 12px;
				color:#9298A8;
			}
		}
		.entryPhone{
			display: flex;
			align-items: center;
			.phone{
				display: inline-block;
				width: 25px;
				height: 25px;
				cursor: pointer;
				background: url($--phone-hide) no-repeat;
				background-size: contain;
			}
			.showPhone{
				background-image: url($--phone-show);
			}
		}
	}

</style>
